import type { Customer } from '~/models/customer'

export const useShippingLocalStorage = () => {
  const localStorageKey = 'checkoutShipping'

  const getShippingFromLocalStorage = (): Customer | null => {
    const raw = localStorage.getItem(localStorageKey)
    if (!raw) return null

    try {
      const parsed = JSON.parse(raw)

      return {
        firstName: String(parsed.firstName ?? ''),
        lastName: String(parsed.lastName ?? ''),
        email: String(parsed.email ?? ''),
        phone: String(parsed.phone ?? ''),
        address: String(parsed.address ?? ''),
        city: String(parsed.city ?? ''),
        state: String(parsed.state ?? ''),
        zip: String(parsed.zip ?? ''),
        country: String(parsed.country ?? ''),
        address2: String(parsed.address2 ?? ''),
      }
    }
    catch (error) {
      console.warn('Failed to parse shipping from localStorage:', error)
      return null
    }
  }

  const saveShippingToLocalStorage = (shipping: Customer): void => {
    localStorage.setItem(localStorageKey, JSON.stringify(shipping))
  }

  const clearShipping = (): void => {
    localStorage.removeItem(localStorageKey)
  }

  return {
    getShippingFromLocalStorage,
    saveShippingToLocalStorage,
    clearShipping,
  }
}
